import React from 'react';
import { Lesson } from '../domain/types';
import './LessonSelectScreen.css';

interface LessonSelectScreenProps {
  lessons: Lesson[];
  onSelectLesson: (lessonIndex: number) => void;
  onGoHome: () => void;
}

const LessonSelectScreen: React.FC<LessonSelectScreenProps> = ({
  lessons,
  onSelectLesson,
  onGoHome
}) => {
  return (
    <div className="lesson-select-screen">
      <div className="lesson-container">
        <div className="lesson-header">
          <h1 className="lesson-title">
            El Reino de la Princesa Cata ✨👑
          </h1>
          <p className="lesson-subtitle">
            Elige una lección para aprender
          </p>
        </div>

        <div className="lessons-grid">
          {lessons.map((lesson, index) => (
            <button
              key={lesson.id}
              className={`lesson-card ${lesson.completed ? 'completed' : ''}`}
              onClick={() => onSelectLesson(index)}
            >
              <div className="lesson-icon">
                {lesson.icon}
              </div>
              <div className="lesson-content">
                <h3 className="lesson-name">{lesson.title}</h3>
                <p className="lesson-description">{lesson.description}</p>
                {lesson.completed && (
                  <div className="completed-badge">✓ Completada</div>
                )}
              </div>
            </button>
          ))}
        </div>

        <button className="home-button" onClick={onGoHome}>
          🏠 Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default LessonSelectScreen;
